import * as React from 'react';
export const IcFlashAuto = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.54 9.47h-2.67l2-5.48a1.48 1.48 0 00-2.54-1.43l-7.7 9.62a2 2 0 001.54 3.2h2.8L8.16 20a1.48 1.48 0 002.52 1.48l7.37-8.75a2 2 0 00-1.51-3.26zM6 7.68a.51.51 0 00.5.32c.06.01.12.01.18 0A.52.52 0 007 7.32l-1.5-4a.52.52 0 00-.94 0L3 7.32a.52.52 0 00.32.68.51.51 0 00.68-.32L4.22 7h1.56l.22.68zM4.6 6L5 4.92 5.4 6h-.8z'
      fill='currentColor'
    />
  </svg>
);
